<template>
  <a-drawer :label-col="5" :visible="open" :wrapper-col="16" width="40%" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="应用端" prop="appIdent">
        <a-select v-model="form.appIdent" placeholder="请选择应用端">
          <a-select-option value="guzhu">雇主端</a-select-option>
          <a-select-option value="shifu">师傅端</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="平台" prop="appType">
        <a-select v-model="form.appType" placeholder="请选择平台">
          <a-select-option :value="0">安卓</a-select-option>
          <a-select-option :value="1">iOS</a-select-option>
          <a-select-option :value="2">通用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="版本名称" prop="versionName">
        <a-input v-model="form.versionName" placeholder="请输入版本名称"/>
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="versionCode">
        <a-input v-model="form.versionCode" placeholder="请输入数字版本号"/>
      </a-form-model-item>
      <a-form-model-item label="更新类型" prop="upType">
        <a-select v-model="form.upType" placeholder="请选择更新类型">
          <a-select-option :value="0">热更新</a-select-option>
          <a-select-option :value="1">整包更新</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="升级策略" prop="compulsoryUp">
        <a-select v-model="form.compulsoryUp" placeholder="请选择升级策略">
          <a-select-option :value="0">强制升级</a-select-option>
          <a-select-option :value="1">可跳过</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="地址类型" prop="upUrlType">
        <a-select v-model="form.upUrlType" placeholder="请选择地址类型">
          <a-select-option :value="0">内部地址</a-select-option>
          <a-select-option :value="1">应用市场</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.upUrlType === 0" label="上传安装包" prop="downloadUrl">
        <a-upload
          :file-list="uploadFileList"
          :before-upload="beforeUpload"
          :custom-request="handleUpload"
          :remove="handleRemoveFile"
          accept=".wgt,.apk"
        >
          <a-button :loading="uploading" :disabled="uploading">
            <a-icon :type="uploading ? 'loading' : 'upload'" />
            {{ uploading ? `上传中 ${uploadPercent}%` : '选择文件' }}
          </a-button>
          <span style="margin-left: 8px; color: #999; font-size: 12px;">支持 .wgt / .apk 格式</span>
        </a-upload>
        <a-input
          v-if="form.downloadUrl"
          v-model="form.downloadUrl"
          disabled
          style="margin-top: 8px"
        >
          <a-tooltip slot="suffix" title="清除地址">
            <a-icon type="close-circle" style="cursor: pointer; color: #999" @click="clearDownloadUrl" />
          </a-tooltip>
        </a-input>
      </a-form-model-item>
      <a-form-model-item v-if="form.upUrlType === 1" label="市场地址" prop="upUrl">
        <a-input v-model="form.upUrl" placeholder="请输入应用市场地址"/>
      </a-form-model-item>
      <a-form-model-item label="生效方式" prop="planUpType">
        <a-select v-model="form.planUpType" placeholder="请选择生效方式">
          <a-select-option :value="0">立即生效</a-select-option>
          <a-select-option :value="1">计划生效</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.planUpType === 1" label="生效时间" prop="planUpTime">
        <a-date-picker
          v-model="form.planUpTime"
          allow-clear
          format="YYYY-MM-DD HH:mm:ss"
          placeholder="请选择生效时间"
          show-time
          style="width: 100%"
          valueFormat="x"
        />
      </a-form-model-item>
      <a-form-model-item label="包大小(KB)" prop="upHeSize">
        <a-input-number v-model="form.upHeSize" :min="0" :precision="0" placeholder="上传后自动填写" style="width: 100%"/>
      </a-form-model-item>
      <a-form-model-item label="更新说明" prop="upNotes">
        <a-input v-model="form.upNotes" :rows="4" placeholder="请输入更新说明" type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" :rows="3" placeholder="请输入备注" type="textarea"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button :loading="submitLoading" type="primary" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getOssConfig } from '@/api/system/upload.js'
import { addAppVersion, getAppVersion, updateAppVersion } from '@/api/app/appVersion'

export default {
  name: 'CreateForm',
  data() {
    return {
      submitLoading: false,
      uploading: false,
      uploadPercent: 0,
      uploadFileList: [],
      formTitle: '',
      form: this.buildForm(),
      formType: 1,
      open: false,
      rules: {
        appIdent: [
          { required: true, message: '应用端不能为空', trigger: 'change' }
        ],
        appType: [
          { required: true, message: '平台不能为空', trigger: 'change' }
        ],
        versionName: [
          { required: true, message: '版本名称不能为空', trigger: 'blur' }
        ],
        versionCode: [
          { required: true, message: '版本号不能为空', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '版本号必须为数字', trigger: 'blur' }
        ],
        upType: [
          { required: true, message: '更新类型不能为空', trigger: 'change' }
        ],
        compulsoryUp: [
          { required: true, message: '升级策略不能为空', trigger: 'change' }
        ],
        upUrlType: [
          { required: true, message: '地址类型不能为空', trigger: 'change' }
        ],
        planUpType: [
          { required: true, message: '生效方式不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    buildForm() {
      return {
        id: null,
        appIdent: undefined,
        appType: undefined,
        versionName: undefined,
        versionCode: undefined,
        upType: 1,
        compulsoryUp: 1,
        upUrlType: 0,
        upUrl: undefined,
        planUpType: 0,
        planUpTime: undefined,
        downloadUrl: undefined,
        upNotes: undefined,
        upHeSize: undefined,
        remark: undefined
      }
    },
    getFileExtension(fileName) {
      const idx = fileName.lastIndexOf('.')
      return idx > -1 ? fileName.substring(idx + 1).toLowerCase() : ''
    },
    beforeUpload(file) {
      const ext = this.getFileExtension(file.name)
      const allowed = ['wgt', 'apk']
      if (!allowed.includes(ext)) {
        this.$message.error('仅支持上传 .wgt 和 .apk 文件')
        return false
      }
      const maxSize = 200
      if (file.size / 1024 / 1024 > maxSize) {
        this.$message.error(`文件大小不能超过 ${maxSize}MB`)
        return false
      }
      return true
    },
    handleUpload({ file }) {
      this.uploading = true
      this.uploadPercent = 0
      const ext = this.getFileExtension(file.name)
      const token = storage.get(ACCESS_TOKEN)
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const date = String(now.getDate()).padStart(2, '0')

      getOssConfig().then(res => {
        const ossData = res.data
        const ossKey = `${year}/${month}/${date}/${ossData.fileName}.${ext}`
        const form = new FormData()
        form.append('key', ossKey)
        form.append('policy', ossData.policy)
        form.append('OSSAccessKeyId', ossData.accessid)
        form.append('success_action_status', '200')
        form.append('signature', ossData.signature)
        form.append('file', file)

        axios({
          url: ossData.resultUrl,
          method: 'post',
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'multipart/form-data'
          },
          data: form,
          onUploadProgress: (e) => {
            if (e.total > 0) {
              this.uploadPercent = Math.round((e.loaded / e.total) * 100)
            }
          }
        }).then(res => {
          if (res.status === 200) {
            const fileUrl = ossData.resultUrl + '/' + ossKey
            this.form.downloadUrl = fileUrl
            this.form.upHeSize = Math.round(file.size / 1024)
            this.uploadFileList = [{
              uid: file.uid,
              name: file.name,
              status: 'done',
              url: fileUrl
            }]
            this.$message.success(`${file.name} 上传成功`)
          } else {
            this.$message.error('上传失败，请重试')
            this.uploadFileList = []
          }
        }).catch(() => {
          this.$message.error('上传失败，请检查网络')
          this.uploadFileList = []
        }).finally(() => {
          this.uploading = false
          this.uploadPercent = 0
        })
      }).catch(() => {
        this.$message.error('获取上传配置失败')
        this.uploading = false
      })
    },
    handleRemoveFile() {
      this.clearDownloadUrl()
      return true
    },
    clearDownloadUrl() {
      this.form.downloadUrl = undefined
      this.form.upHeSize = undefined
      this.uploadFileList = []
    },
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = this.buildForm()
      this.uploadFileList = []
      this.uploading = false
      this.uploadPercent = 0
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增版本'
    },
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAppVersion({ id }).then(response => {
        const d = response.data
        this.form = {
          ...this.buildForm(),
          ...d,
          appType: d.appType != null ? Number(d.appType) : undefined,
          upType: d.upType != null ? Number(d.upType) : undefined,
          compulsoryUp: d.compulsoryUp != null ? Number(d.compulsoryUp) : undefined,
          upUrlType: d.upUrlType != null ? Number(d.upUrlType) : undefined,
          planUpType: d.planUpType != null ? Number(d.planUpType) : undefined,
          planUpTime: d.planUpTime ? String(d.planUpTime) : undefined
        }
        if (d.downloadUrl) {
          const url = d.downloadUrl
          this.uploadFileList = [{
            uid: '-1',
            name: url.substring(url.lastIndexOf('/') + 1) || '安装包',
            status: 'done',
            url: url
          }]
        }
        this.open = true
        this.formTitle = '修改版本'
      })
    },
    validateBusinessRules() {
      if (this.form.upUrlType === 0 && !this.form.downloadUrl) {
        this.$message.error('内部地址模式下必须上传安装包')
        return false
      }
      if (this.form.upUrlType === 1 && !this.form.upUrl) {
        this.$message.error('应用市场模式下必须填写市场地址')
        return false
      }
      if (this.form.planUpType === 1 && !this.form.planUpTime) {
        this.$message.error('计划生效模式下必须选择生效时间')
        return false
      }
      return true
    },
    buildSubmitForm() {
      return {
        ...this.form,
        downloadUrl: this.form.downloadUrl || '',
        upUrl: this.form.upUrl || '',
        planUpTime: this.form.planUpType === 0 ? null : Number(this.form.planUpTime)
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid || !this.validateBusinessRules()) {
          return false
        }
        this.submitLoading = true
        const submitData = this.buildSubmitForm()
        const submitRequest = submitData.id ? updateAppVersion(submitData) : addAppVersion(submitData)
        submitRequest.then(() => {
          this.$message.success(submitData.id ? '修改成功' : '新增成功', 3)
          this.open = false
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
